<div class="product-item">
  <img class="icon" [src]="icon" alt="product icon" />
  <div class="ticket-info">
    <p class="product-name">
      <span class="ticket-id">#{{ ticket.id }} - </span
      >{{ ticket.product.name }}
    </p>

    @if (getLatestPetition(ticket); as petition) {
    <span
      class="petition-tag"
      [ngClass]="{
        'pending-edit':
          petition.status === 'pending' && petition.type === 'edit',
        'pending-delete':
          petition.status === 'pending' && petition.type === 'delete',
        approved: petition.status === 'approved',
        rejected: petition.status === 'rejected'
      }"
    >
      {{ getPetitionLabel(petition) }}
    </span>
    }

    @if (!hideEventLine) {
    <p class="ticket-detail">
      {{ "tickets-sold.event" | translate }} {{ ticket.event.name }}
    </p>
    } @if (shouldShowReference(ticket)) {
    <p class="ticket-detail">
      {{ "tickets-sold.reference" | translate }} {{ ticket.reference }}
    </p>
    } @if (ticket.fullname) {
    <p class="ticket-detail">
      {{ "tickets-sold.buyer" | translate }} {{ ticket.fullname }}
    </p>
    } @if (ticket.ecommerce) {
    <div class="ticket-meta">
      @if (ticket.payment_method !== 'pay_at_door') {
      <span class="transaction-date">
        {{ ticket.latest_transaction?.created_at | date : "dd/MM HH:mm" }}
      </span>
      <span class="separator">-</span>
      <span class="payment-method">
        {{ getPaymentMethodLabel(ticket.payment_method) }}
      </span>
      } @else {
      <img src="assets/icons/method-payment-icon.svg" class="ticket-icon" />
      <span class="collection-type">
        {{ "payment-product-modal.collection-type.third-party" | translate }}
      </span>
      }
    </div>
    }

    <!-- Direct Sale -->
    @if (!ticket.ecommerce) {
    <div class="ticket-meta">
      <span class="payment-method-chip">
        {{
          ticket.payment_method === "pay_at_door"
            ? ("payment-product-modal.collection-type.third-party" | translate)
            : ("payment-product-modal.collection-type.own" | translate)
        }}
      </span>
      <span class="price">{{ getTicketAmount(ticket) | arsCurrency }}</span>
      <span class="ticket-sold">
        <img src="assets/icons/ticket-qr-code.svg" class="ticket-qr" />
        <span> {{ ticket.assistants_count }}/{{ ticket.quota }} </span>
      </span>
    </div>
    } @if (ticket.ecommerce) {
    <div class="ticket-meta">
      <span class="price">{{ getPaidAmount(ticket) | arsCurrency }}</span>
      <span class="ticket-sold">
        <img src="assets/icons/ticket-qr-code.svg" class="ticket-qr" />
        <span> {{ ticket.assistants_count }}/{{ ticket.quota }} </span>
      </span>
    </div>
    }
  </div>
  <div class="dropdown-button" (click)="openOptionsModal()">
    <ion-icon name="ellipsis-vertical" class="options-icon" />
  </div>
</div>
